// @flow
import * as React from "react";
import { reisy, use } from "reisy";
import { observer } from "mobx-react";

import type { Publishable } from "../api/types.js";
import Section from "../publishables/section.js";
import Navigation from "../navigation/index.js";
import Footer from "../components/footer.js";
import { isIOS } from "../environment.js";
import { isMobile, isIE, hasPositionStickySupport } from "../environment.js";
import { Header, Background, styles as header } from "../components/header.js";
import { Value } from "../components/value.js";

const styles = reisy`
@namespace CollectionScreen;

showBack: true;
showShare: true;
showFooter: false;
showHeader: false;
JackInTheBox: $Settings.JackInTheBox;
ContrastHint: #ffffff;

Container {
	@extends Helpers.Fullscreen;
	display: flex;
	flex-direction: column;
	min-height: 100vh;

	&, & *, & *::after, & *::before {
		box-sizing: border-box;
	}
}
Contain {
	@extends Helpers.Contain;
	@extends Helpers.FontSize;
}
Scroll {
	overflow-y: auto;
	overflow-x: hidden;
	-webkit-overflow-scrolling: touch;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}
isMobile {

}
isDesktop {

}
isIE {

}
noPositionStickySupport {

}
`;

type Props = {
	content: Publishable,
};

const CollectionScreen = ({ content, isEmbedded, host }: Props) => {
	const classes =
		content &&
		content.options &&
		content.options.className &&
		content.options.className.split(" ").map((c, i) => `CollWrapClass__${c}`);
	const { publisher } = content;
	return (
		<div
			{...use(
				styles.Container,
				styles.JackInTheBox && styles.Contain,
				isIOS && isEmbedded ? styles.Scroll : null,
				classes && classes,
				isMobile ? styles.isMobile : styles.isDesktop,
				isIE && styles.isIE,
				!hasPositionStickySupport && styles.noPositionStickySupport
			)}
			data-host={host}
		>
			<Navigation styles={styles} contrastHint={styles.ContrastHint} />
			{styles.showHeader && (
				<React.Fragment>
					<Background
						background={publisher.background}
						windowHeight={Value(IS_BROWSER ? window.innerHeight : 768)}
					/>
					<Header
						publisher={publisher}
						type={publisher.type}
						onScrollToContent={() => null}
						windowHeight={Value(IS_BROWSER ? window.innerHeight : 768)}
					/>
				</React.Fragment>
			)}
			<Section
				content={content}
				fullscreen={!styles.JackInTheBox}
				headingLvl={1}
				root={true}
			/>
			{styles.showFooter && <Footer publisher={content.publisher} />}
		</div>
	);
};

export default observer(CollectionScreen);



// WEBPACK FOOTER //
// ./lib/screens/collection.js